import * as React from 'react';

import styles from './iframe-component.module.css';

type Props = {
    src: string;
    title: string;
    onLoad?: () => void;
};

/**
 * Simple iframe wrapper for embedding nutshell.com pages in modals or full-page views.
 *
 * Used for: plan comparison modal, refer-a-friend modal, marketing guides page,
 * CRM advertising page, SQL access page, marketing services page.
 *
 * For non-interactive previews with browser chrome, use `BrowserPreview` instead.
 */
export function IframeComponent(props: Props) {
    return (
        <div className={styles.container}>
            <iframe
                src={props.src}
                title={props.title}
                onLoad={props.onLoad}
                className={styles.content}
            ></iframe>
        </div>
    );
}
